module.exports = __webpack_public_path__ + "media/bg_video_colour_LR.64020482.mp4";